module.exports = __webpack_public_path__ + "img/logo@3x3.bd813c57.png";